/*
 * AppConstants
 */

// APP
export const CHANGE_TITLE = 'App/CHANGE_TITLE';

// VERSION
export const VERSION = 'VERSION';

// IOC
export const UPDATE_FILTER = 'App/UPDATE_FILTER';
export const UPDATE_TAG = 'App/UPDATE_TAG';
export const UPDATE_SORTING = 'App/UPDATE_SORTING';
export const UPDATE_PAGINATION = 'App/UPDATE_PAGINATION';
export const UPDATE_IOC_LIST = 'App/UPDATE_IOC_LIST';
export const UPDATE_IOC_LIST_FROM_CACHE = 'App/UPDATE_IOC_LIST_FROM_CACHE';
export const PAGINATION_IOC_LIST = 'App/PAGINATION_IOC_LIST';
export const PAGINATION_IOC_LIST_FROM_CACHE =
  'App/PAGINATION_IOC_LIST_FROM_CACHE';
export const FILTER_SWITCH = 'App/FILTER_SWITCH';
export const EXPORT_LIST_TO_CSV = 'App/EXPORT_LIST_TO_CSV';
export const EXPORT_LIST_TO_SPLUNK = 'App/EXPORT_LIST_TO_SPLUNK';
export const EXPORT_LIST_TO_STIX = 'App/EXPORT_LIST_TO_STIX';
export const EXPORT_LIST_TO_STIX_LIMITED = 'App/EXPORT_LIST_TO_STIX_LIMITED';
export const RESET_STIX_EXPORT_LIMITED_STATUS =
  'App/RESET_STIX_EXPORT_LIMITED_STATUS';
export const EXPORT_LIST_TO_JSON = 'App/EXPORT_LIST_TO_JSON';
export const EXPORT_SINGLE_IOC = 'App/EXPORT_SINGLE_IOC';
export const EXPORT_EXPLORE_RESULT_TO_CSV = 'App/EXPORT_EXPLORE_RESULT_TO_CSV';
export const EXPORT_SPOOFING_TO_CSV = 'App/EXPORT_SPOOFING_TO_CSV';
export const EXPORT_SPOOFING_TO_JSON = 'App/EXPORT_SPOOFING_TO_JSON';
export const EXPORT_DANGLING_DNS_TO_CSV = 'App/EXPORT_DANGLING_DNS_TO_CSV';
export const EXPORT_DANGLING_DNS_TO_JSON = 'App/EXPORT_DANGLING_DNS_TO_JSON';
export const EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV =
  'App/EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV';
export const EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON =
  'App/EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON';
export const EXPORT_SUBDOMAIN_FINDER_TO_CSV =
  'App/EXPORT_SUBDOMAIN_FINDER_TO_CSV';
export const EXPORT_SUBDOMAIN_FINDER_TO_JSON =
  'App/EXPORT_SUBDOMAIN_FINDER_TO_JSON';
export const EXPORT_SHADOW_IT_TO_CSV = 'App/EXPORT_SHADOW_IT_TO_CSV';
export const EXPORT_SHADOW_IT_TO_JSON = 'App/EXPORT_SHADOW_IT_TO_JSON';
export const EXPORT_EXPLORE_RESULT_TO_JSON =
  'App/EXPORT_EXPLORE_RESULT_TO_JSON';
export const CLEAR_SCORE_DETAILS = 'App/CLEAR_SCORE_DETAILS';
export const LOAD_SCORE_DETAILS = 'App/LOAD_SCORE_DETAILS';
export const LOAD_NEW_SCORE_DETAILS = 'App/LOAD_NEW_SCORE_DETAILS';
export const CLEAR_EXPLORE_SCORE_DETAILS = 'App/CLEAR_EXPLORE_SCORE_DETAILS';
export const SAVE_MONITORING_QUERY = 'App/SAVE_MONITORING_QUERY';
export const UPDATE_MONITORING_QUERY = 'App/UPDATE_MONITORING_QUERY';
export const LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS =
  'App/LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS';
export const LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS =
  'App/LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS';
export const LOAD_UTILS_PARSE_IOC = 'App/LOAD_UTILS_PARSE_IOC';
export const RESET_UTILS_PARSE_IOC_STATUS = 'App/RESET_UTILS_PARSE_IOC_STATUS';
export const RESET_ENRICHMENT_STATUS = 'App/RESET_ENRICHMENT_STATUS';
export const RESET_FILTER_PROFILE = 'App/RESET_FILTER_PROFILE';
export const RESET_RECIPE_STATUS = 'App/RESET_RECIPE_STATUS';
export const RESET_ASN_AUTOFILL_STATUS = 'App/RESET_ASN_AUTOFILL_STATUS';
export const RESET_CREATE_ORGANIZATION_STATUS =
  'App/RESET_CREATE_ORGANIZATION_STATUS';
export const RESET_SPECIFIC_FILTER = 'App/RESET_SPECIFIC_FILTER';

export const LOAD_HISTORY_QUERIES = 'App/LOAD_HISTORY_QUERIES';
export const UPDATE_HISTORY_QUERY = 'App/UPDATE_HISTORY_QUERY';
export const ADD_NEW_HISTORY_QUERY = 'App/ADD_NEW_HISTORY_QUERY';
export const LOAD_HISTORY_QUERY_RESULT = 'App/LOAD_HISTORY_QUERY_RESULT';
export const COPY_HISTORY_QUERY_RESULT = 'App/COPY_HISTORY_QUERY_RESULT';
export const CLEAR_COPY_HISTORY_QUERY_RESULT =
  'App/CLEAR_COPY_HISTORY_QUERY_RESULT';
export const DOWNLOAD_HISTORY_QUERY_RESULT =
  'App/DOWNLOAD_HISTORY_QUERY_RESULT';

export const LOAD_MONITORING_FILE = 'App/LOAD_MONITORING_FILE';
export const LOAD_MONITORING_JSON_FILE = 'App/LOAD_MONITORING_JSON_FILE';
export const LOAD_MONITORING_QUERIES = 'App/LOAD_MONITORING_QUERIES';
export const DELETE_MONITORING_QUERY = 'App/DELETE_MONITORING_QUERY';
export const CHANGE_SCOPE_MONITORING_QUERY =
  'App/CHANGE_SCOPE_MONITORING_QUERY';
export const RUN_MONITORING_QUERY = 'App/RUN_MONITORING_QUERY';
export const LOAD_MONITORING_QUERY_RESULTS_HISTORY =
  'App/LOAD_MONITORING_QUERY_RESULTS_HISTORY';
export const LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS =
  'App/LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS';
export const LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA =
  'App/LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA';
export const SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA =
  'App/SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA';
export const DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA =
  'App/DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA';
export const LOAD_ATTACK_SURFACE_MAPPING = 'App/LOAD_ATTACK_SURFACE_MAPPING';
export const LOAD_DIGITAL_THREAT_MANAGEMENT =
  'App/LOAD_DIGITAL_THREAT_MANAGEMENT';
export const LOAD_MERGE_API_EXPLORE_RECIPES =
  'App/LOAD_MERGE_API_EXPLORE_RECIPES';
export const LOAD_MERGE_API_EXPLORE_RECIPE =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE';
export const LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A';
export const DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A';
export const SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A';
export const LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS';
export const DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS';
export const SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS';
export const LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES';
export const DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES';
export const SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES';
export const LOAD_MERGE_API_EXPLORE_RECIPE_TXT =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_TXT';
export const DELETE_MERGE_API_EXPLORE_RECIPE_TXT =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_TXT';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_TXT =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_TXT';
export const SAVE_MERGE_API_EXPLORE_RECIPE_TXT =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_TXT';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT';
export const LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY';
export const SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY';
export const DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY';
export const LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS';
export const SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS';
export const DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS';

export const LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA =
  'App/LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA';

export const LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS';
export const SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS';
export const DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS';

export const LOAD_DANGLING_DNS_RECORDS_COUNT_DATA =
  'App/LOAD_DANGLING_DNS_RECORDS_COUNT_DATA';

export const LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT';
export const SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT';
export const DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT';

export const LOAD_DANGLING_DNS_PROTECTION_DATA =
  'App/LOAD_DANGLING_DNS_PROTECTION_DATA';

export const LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION';
export const SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION';
export const DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION';

export const LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER';
export const SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER';
export const DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER';

export const LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT';
export const SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT';
export const DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT';

export const DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A';
export const LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A';
export const SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A';
export const LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER';
export const DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER';
export const SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER';
export const LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING';
export const DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING';
export const SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING';

export const LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT =
  'App/LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT';
export const SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT =
  'App/SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT';
export const UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT =
  'App/UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT';
export const DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT =
  'App/DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT';
export const CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT =
  'App/CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT';
export const QUERY_NAME_IN_TXT_RECIPE = 'App/QUERY_NAME_IN_TXT_RECIPE';
export const CLONE_RECIPE = 'App/CLONE_RECIPE';

export const LOAD_MERGE_API_IP_SCORE_DETAILS =
  'App/LOAD_MERGE_API_IP_SCORE_DETAILS';
export const LOAD_MERGE_API_DOMAIN_SCORE_DETAILS =
  'App/LOAD_MERGE_API_DOMAIN_SCORE_DETAILS';
export const LOAD_MERGE_API_EXPLORE_SCORE_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_SCORE_DETAILS';
export const LOAD_NAME_SERVER_AUTOFILL = 'App/LOAD_NAME_SERVER_AUTOFILL';
export const LOAD_DNS_RECORDS = 'App/LOAD_DNS_RECORDS';
export const LOAD_A_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_A_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_MX_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_MX_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_NS_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_NS_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT =
  'App/LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT';
export const LOAD_IP_DENSITY = 'App/LOAD_IP_DENSITY';
export const LOAD_PTR_LOOKUP = 'App/LOAD_PTR_LOOKUP';
export const LOAD_ASN_AUTOFILL = 'App/LOAD_ASN_AUTOFILL';
export const LOAD_MERGE_API_MERGE_SCORE_DETAILS =
  'App/LOAD_MERGE_API_MERGE_SCORE_DETAILS';
export const POST_MERGE_API_EXPLORE_SCORE_DETAILS =
  'App/POST_MERGE_API_EXPLORE_SCORE_DETAILS';
export const POST_MERGE_API_MERGE_SCORE_DETAILS =
  'App/POST_MERGE_API_MERGE_SCORE_DETAILS';
export const LOAD_MERGE_API_DOMAIN_INFRA_TAGS =
  'APP/LOAD_MERGE_API_DOMAIN_INFRA_TAGS';
export const LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS';
export const LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS';
export const LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS';
export const LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS';
export const LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS =
  'App/LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS';
export const LOAD_MERGE_API_RISK_SCORES = 'App/LOAD_MERGE_API_RISK_SCORES';
export const LOAD_MERGE_API_ASN_DETAILS = 'App/LOAD_MERGE_API_ASN_DETAILS';
export const TOGGLE_FALSE_POSITIVE = 'App/TOGGLE_FALSE_POSITIVE';
export const TOGGLE_TRUE_POSITIVE = 'App/TOGGLE_TRUE_POSITIVE';
export const CREATE_IOC = 'App/CREATE_IOC';
export const LOAD_IOC_NOTES = 'App/LOAD_IOC_NOTES';
export const DELETE_IOC_NOTE = 'App/DELETE_IOC_NOTE';
export const CREATE_IOC_NOTE = 'App/CREATE_IOC_NOTE';
export const UPDATE_IOC_NOTE = 'App/UPDATE_IOC_NOTE';
export const DELETE_IOC = 'App/DELETE_IOC';
export const DELETE_IOC_FROM_COLLECTION = 'App/DELETE_IOC_FROM_COLLECTION';
export const LOAD_IOCS_FROM_SPECIFIC_COLLECTION =
  'App/LOAD_IOCS_FROM_SPECIFIC_COLLECTION';
export const LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION =
  'App/LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION';
export const LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION =
  'App/LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION';
export const SAVE_BREADCRUMBS = 'App/SAVE_BREADCRUMBS';
export const LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS =
  'App/LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS';
export const LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS =
  'App/LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS_RECIPE_RESULTS';
export const LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS =
  'App/LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS';
export const LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS =
  'App/LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS_RECIPE_RESULTS';
export const LOAD_SHADOW_IT_RECIPE_RESULTS =
  'App/LOAD_SHADOW_IT_RECIPE_RESULTS';
export const LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS =
  'App/LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS';
export const SET_FEED_STATE_FILTER = 'App/SET_FEED_STATE_FILTER';
export const SET_CLEAR_RECIPE = 'App/SET_CLEAR_RECIPE';
export const UNSET_CLEAR_RECIPE = 'App/UNSET_CLEAR_RECIPE';

// Auth
export const LOGIN = 'App/LOGIN';
export const IMPERSONATE = 'App/IMPERSONATE';
export const CHECK_TOKEN = 'App/CHECK_TOKEN';
export const REFRESH_TOKEN = 'App/REFRESH_TOKEN';
export const LOGOUT = 'App/LOGOUT';
export const VALIDATE_EMAIL_ON_REGISTER = 'App/VALIDATE_EMAIL_ON_REGISTER';
export const VALIDATE_PASSWORD = 'App/VALIDATE_PASSWORD';
export const RESET_PASSWORD = 'App/RESET_PASSWORD';
export const CONFIRM_PASSWORD_RESET = 'App/CONFIRM_PASSWORD_RESET';
export const ENABLE_2FA = 'App/ENABLE_2FA';
export const LOGIN_WITH_2FA = 'App/LOGIN_WITH_2FA';
export const LOAD_2FA_QR = 'App/LOAD_2FA_QR';
export const REMOVE_2FA = 'App/REMOVE_2FA';
export const REGISTER = 'App/REGISTER';

// Subscription
export const CONFIRM_EXTEND_SUBSCRIPTION = 'App/CONFIRM_EXTEND_SUBSCRIPTION';

// User
export const INVITE_USER = 'App/INVITE_USER';
export const LOAD_USER = 'App/LOAD_USER';
export const LOAD_ORGANIZATION = 'App/LOAD_ORGANIZATION';
export const UPDATE_USER_PROFILE = 'App/UPDATE_USER_PROFILE';
export const LOAD_USER_PREFERENCES = 'App/LOAD_USER_PREFERENCES';
export const UPDATE_USER_PREFERENCES = 'App/UPDATE_USER_PREFERENCES';
export const UPDATE_USER_ORGANIZATION = 'App/UPDATE_USER_ORGANIZATION';
export const UPLOAD_PHOTO = 'App/UPLOAD_PHOTO';
export const LOAD_USERS = 'App/LOAD_USERS';
export const LOAD_USERS_INFO = 'App/LOAD_USERS_INFO';
export const CREATE_USER = 'App/CREATE_USER';
export const DELETE_USER = 'App/DELETE_USER';
export const UPDATE_USER = 'App/UPDATE_USER';
export const CHANGE_PASSWORD = 'App/CHANGE_PASSWORD';
export const SET_CUSTOM_IP_RANGE_INDICATOR =
  'App/SET_CUSTOM_IP_RANGE_INDICATOR';
export const SET_CUSTOM_GEO_IP = 'App/SET_CUSTOM_GEO_IP';
export const LOAD_CUSTOM_GEO_IP = 'App/LOAD_CUSTOM_GEO_IP';
export const LOAD_CUSTOM_GEO_IP_ORGANISATION =
  'App/LOAD_CUSTOM_GEO_IP_ORGANISATION';
export const SET_CUSTOM_DOMAIN_INDICATORS = 'App/SET_CUSTOM_DOMAIN_INDICATORS';
export const DELETE_CUSTOM_DOMAIN_INDICATORS =
  'App/DELETE_CUSTOM_DOMAIN_INDICATORS';
export const LOAD_CUSTOM_DOMAIN_INDICATORS =
  'App/LOAD_CUSTOM_DOMAIN_INDICATORS';
export const LOAD_CUSTOM_IP_RANGE_INDICATORS =
  'App/LOAD_CUSTOM_IP_RANGE_INDICATORS';
export const SET_CUSTOM_IP_RANGE_INDICATORS =
  'App/SET_CUSTOM_IP_RANGE_INDICATORS';
export const UPDATE_CUSTOM_IP_RANGE_INDICATORS =
  'App/UPDATE_CUSTOM_IP_RANGE_INDICATORS';
export const DELETE_CUSTOM_IP_RANGE_INDICATORS =
  'App/DELETE_CUSTOM_IP_RANGE_INDICATORS';

// Groups
export const LOAD_GROUPS = 'App/LOAD_GROUPS';
export const CREATE_GROUP = 'App/CREATE_GROUP';
export const UPDATE_GROUP = 'App/UPDATE_GROUP';
export const DELETE_GROUP = 'App/DELETE_GROUP';

// Departments
export const LOAD_DEPARTMENTS = 'App/LOAD_DEPARTMENTS';
export const CREATE_DEPARTMENT = 'App/CREATE_DEPARTMENT';
export const UPDATE_DEPARTMENT = 'App/UPDATE_DEPARTMENT';
export const DELETE_DEPARTMENT = 'App/DELETE_DEPARTMENT';

// APIAccess
export const LOAD_API_ACCESS = 'App/LOAD_API_ACCESS';
export const CREATE_API_ACCESS = 'App/CREATE_API_ACCESS';
export const UPDATE_API_ACCESS = 'App/UPDATE_API_ACCESS';
export const DELETE_API_ACCESS = 'App/DELETE_API_ACCESS';

// Permissions
export const REQUEST_PERMISSION = 'App/REQUEST_PERMISSION';
export const LOAD_PERMISSIONS = 'App/LOAD_PERMISSIONS';

// Filters
export const LOAD_FILTERS = 'App/LOAD_FILTERS';
export const LOAD_SPECIFIC_FILTER = 'App/LOAD_SPECIFIC_FILTER';
export const LOAD_TAG_OPTIONS = 'App/LOAD_TAG_OPTIONS';
export const AUTO_COMPLETE_TAG_OPTIONS = 'App/AUTO_COMPLETE_TAG_OPTIONS';
export const RESET_TAG_OPTIONS = 'App/RESET_TAG_OPTIONS';
export const TOGGLE_FILTER_SIDEBAR = 'App/TOGGLE_FILTER_SIDEBAR';
export const CLOSE_FILTER_SIDEBAR = 'App/CLOSE_FILTER_SIDEBAR';
export const TOGGLE_LEFT_MENU_SIDEBAR = 'App/TOGGLE_LEFT_MENU_SIDEBAR';
export const OPEN_CREATE_NEW_SIDEBAR = 'App/OPEN_CREATE_NEW_SIDEBAR';
export const OPEN_EDIT_SIDEBAR = 'App/OPEN_EDIT_SIDEBAR';
export const LOAD_FILTER_PROFILES = 'App/LOAD_FILTER_PROFILES';
export const CHANGE_FILTER_PROFILE_SCOPE = 'App/CHANGE_FILTER_PROFILE_SCOPE';
export const CHANGE_FILTER_PROFILE_NAME = 'App/CHANGE_FILTER_PROFILE_NAME';
export const SAVE_FILTER_PROFILE = 'App/SAVE_FILTER_PROFILE';
export const SAVE_FILTER_PROFILE_LOCALLY = 'App/SAVE_FILTER_PROFILE_LOCALLY';
export const CHANGE_SELECTED_FILTER_PROFILE =
  'App/CHANGE_SELECTED_FILTER_PROFILE';
export const RESET_SELECTED_FILTER_PROFILE =
  'App/RESET_SELECTED_FILTER_PROFILE';
export const SET_ORIGINAL_FILTER_PROFILES = 'App/SET_ORIGINAL_FILTER_PROFILES';
export const UPDATE_FILTER_PROFILE = 'App/UPDATE_FILTER_PROFILE';
export const CLEAR_FILTER_PROFILE = 'App/CLEAR_FILTER_PROFILE';
export const DELETE_FILTER_PROFILE = 'App/DELETE_FILTER_PROFILE';
export const APPLY_FILTERS = 'App/APPLY_FILTERS';
export const UPDATE_DISTINCT = 'App/UPDATE_DISTINCT';

// Integrations
export const LOAD_SPLUNK = 'App/LOAD_SPLUNK';
export const UPDATE_SPLUNK = 'App/UPDATE_SPLUNK';
export const SAVE_SPLUNK = 'App/SAVE_SPLUNK';
export const DELETE_SPLUNK = 'App/DELETE_SPLUNK';
export const LOAD_SLACK = 'App/LOAD_SLACK';
export const SAVE_SLACK = 'App/SAVE_SLACK';
export const UPDATE_SLACK = 'App/UPDATE_SLACK';
export const DELETE_SLACK = 'App/DELETE_SLACK';
export const LOAD_M_TEAMS = 'App/LOAD_M_TEAMS';
export const SAVE_M_TEAMS = 'App/SAVE_M_TEAMS';
export const UPDATE_M_TEAMS = 'App/UPDATE_M_TEAMS';
export const DELETE_M_TEAMS = 'App/DELETE_M_TEAMS';
export const GET_ACCESS_TOKEN_BROWSERLING = 'App/GET_ACCESS_TOKEN_BROWSERLING';

//Sources
export const LOAD_SOURCES = 'App/LOAD_SOURCES';
export const LOAD_SOURCE = 'App/LOAD_SOURCE';
export const LOAD_NEW_SOURCES = 'App/LOAD_NEW_SOURCES';
export const LOAD_SOURCES_IOC_COUNTS = 'App/LOAD_SOURCES_IOC_COUNTS';
export const LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE =
  'App/LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE';
export const CREATE_EMPTY_SOURCE = 'App/CREATE_EMPTY_SOURCE';
export const CREATE_URL_SOURCE = 'App/CREATE_URL_SOURCE';
export const CREATE_FILE_SOURCE = 'App/CREATE_FILE_SOURCE';
export const DELETE_SOURCE = 'App/DELETE_SOURCE';
export const CHANGE_SOURCE_SCOPE = 'App/CHANGE_SOURCE_SCOPE';
export const ACTIVATE_SOURCE = 'App/ACTIVATE_SOURCE';
export const UPDATE_SOURCE = 'App/UPDATE_SOURCE';
export const UPDATE_FILE_SOURCE = 'App/UPDATE_FILE_SOURCE';
export const ADD_IOC_JSON = 'App/ADD_IOC_JSON';
export const PUBLISH_SOURCE = 'App/PUBLISH_SOURCE';

// Feeds
export const LOAD_GLOBAL_FEEDS = 'App/LOAD_GLOBAL_FEEDS';
export const LOAD_FEEDS_GLOBAL = 'App/LOAD_FEEDS_GLOBAL';
export const LOAD_NEW_FEEDS_GLOBAL = 'App/LOAD_NEW_FEED_GLOBAL';
export const LOAD_FEED_PERFORMANCE = 'App/LOAD_FEED_PERFORMANCE';
export const CLEAR_SOURCES_REPORTS = 'App/CLEAR_SOURCES_REPORTS';
export const LOAD_SOURCES_REPORTS = 'App/LOAD_SOURCES_REPORTS';
export const LOAD_SOURCE_REPORT = 'App/LOAD_SOURCE_REPORT';
export const CONSUME_FEED_DATA = 'App/CONSUME_FEED_DATA';
export const CONSUME_FILE_DATA = 'App/CONSUME_FILE_DATA';
export const CREATE_VIRTUAL_FEED = 'App/CREATE_VIRTUAL_FEED';
export const UPDATE_VIRTUAL_FEED = 'App/UPDATE_VIRTUAL_FEED';
export const CREATE_GLOBAL_FEED = 'App/CREATE_GLOBAL_FEED';
export const UPDATE_GLOBAL_FEED = 'App/UPDATE_GLOBAL_FEED';
export const DELETE_GLOBAL_FEED = 'App/DELETE_GLOBAL_FEED';
export const VERIFY_FEED_AUTH = 'App/VERIFY_FEED_AUTH';
export const RESET_FEED_STATUS = 'App/RESET_FEED_STATUS';
export const LOAD_FEEDS = 'App/LOAD_FEEDS';
export const LOAD_NEW_FEEDS = 'App/LOAD_NEW_FEEDS';
export const LOAD_MY_FEEDS = 'App/LOAD_MY_FEEDS';
export const LOAD_NEW_MY_FEEDS = 'App/LOAD_NEW_MY_FEEDS';
export const LOAD_ORGANIZATION_FEEDS = 'App/LOAD_ORGANIZATION_FEEDS';
export const LOAD_NEW_ORGANIZATION_FEEDS = 'App/LOAD_NEW_ORGANIZATION_FEEDS';
export const LOAD_ALL_FEEDS = 'App/LOAD_ALL_FEEDS';
export const LOAD_COLLECTIONS = 'App/LOAD_COLLECTIONS';
export const LOAD_ORGANIZATION_COLLECTIONS =
  'App/LOAD_ORGANIZATION_COLLECTIONS';
export const LOAD_MY_COLLECTIONS = 'App/LOAD_MY_COLLECTIONS';
export const NEW_LOAD_GLOBAL_FEEDS = 'App/NEW_LOAD_GLOBAL_FEEDS';
export const SAVE_EMPTY_COLLECTION = 'App/SAVE_EMPTY_COLLECTION';
export const SIMPLE_ADD_FEED = 'App/SIMPLE_ADD_FEED';
export const DELETE_EMPTY_FEED = 'App/DELETE_EMPTY_FEED';
export const CREATE_FEED = 'App/CREATE_FEED';
export const UPDATE_FEED = 'App/UPDATE_FEED';
export const DELETE_FEED = 'App/DELETE_FEED';
export const DELETE_MY_FEED = 'App/DELETE_MY_FEED';
export const DELETE_ORGANIZATION_FEED = 'App/DELETE_ORGANIZATION_FEED';
export const EXPORT_FEED = 'App/EXPORT_FEED';
export const DELETE_COLLECTION = 'App/DELETE_COLLECTION';
export const LOAD_COLLECTION = 'App/LOAD_COLLECTION';
export const UPDATE_COLLECTION = 'App/UPDATE_COLLECTION';
export const CHANGE_SCOPE_COLLECTION = 'App/CHANGE_SCOPE_COLLECTION';
export const PUBLISH_COLLECTION = 'App/PUBLISH_COLLECTION';
export const SHARE_COLLECTION = 'App/SHARE_COLLECTION';
export const UPLOAD_TO_COLLECTION = 'App/UPLOAD_TO_COLLECTION';
export const CREATE_COLLECTION_BY_FILE_UPLOAD =
  'App/CREATE_COLLECTION_BY_FILE_UPLOAD';
export const CREATE_COLLECTION_BY_URL_UPLOAD =
  'App/CREATE_COLLECTION_BY_URL_UPLOAD';
export const ACTIVATE_COLLECTION = 'App/ACTIVATE_COLLECTION';
export const ACTIVATE_FEED = 'App/ACTIVATE_FEED';
export const ACTIVATE_MY_FEED = 'App/ACTIVATE_MY_FEED';
export const ACTIVATE_ORGANIZATION_FEED =
  'App/ACTIVATE_ORGANIZATION_COLLECTION';

export const LOAD_AVAILABLE_FEEDS = 'App/LOAD_AVAILABLE_FEEDS';
export const LOAD_IP_EDITABLE_FEEDS = 'App/LOAD_IP_EDITABLE_FEEDS';
export const LOAD_DOMAIN_EDITABLE_FEEDS = 'App/LOAD_DOMAIN_EDITABLE_FEEDS';
export const LOAD_URL_EDITABLE_FEEDS = 'App/LOAD_URL_EDITABLE_FEEDS';

// Tags
export const LOAD_TAGS = 'App/LOAD_TAGS';
export const LOAD_IOC_TAGS = 'App/LOAD_IOC_TAGS';
export const SEARCH_FOR_TAGS = 'App/SEARCH_FOR_TAGS';
export const RESET_TAG_SEARCH = 'App/RESET_TAG_SEARCH';
export const UPDATE_IOC_TAGS = 'App/UPDATE_IOC_TAGS';
export const ADD_IOC_TAG = 'App/ADD_IOC_TAG';
export const REMOVE_IOC_TAG = 'App/REMOVE_IOC_TAG';
export const DELETE_TAG = 'App/DELETE_TAG';

// Dashboards
export const LOAD_DASHBOARDS = 'App/LOAD_DASHBOARDS';
export const LOAD_DASHBOARD_DETAILS = 'App/LOAD_DASHBOARD_DETAILS';
export const CREATE_DASHBOARD = 'App/CREATE_DASHBOARD';
export const UPDATE_DASHBOARD = 'App/UPDATE_DASHBOARD';
export const DELETE_DASHBOARD = 'App/DELETE_DASHBOARD';
export const LOAD_WIDGETS = 'App/LOAD_WIDGETS';
export const UPDATE_DASHBOARD_CELL = 'App/UPDATE_DASHBOARD_CELL';

// Widgets
export const LOAD_MOST_WIDESPREAD_TAG = 'App/LOAD_MOST_WIDESPREAD_TAG';
export const LOAD_TOP_TRENDING_TAGS = 'App/LOAD_TOP_TRENDING_TAGS';
export const LOAD_FP_AVG = 'App/LOAD_FP_AVG';

//Playbooks
export const LOAD_PLAYBOOKS = 'App/LOAD_PLAYBOOKS';
export const LOAD_PLAYBOOKS_LOGS = 'App/LOAD_PLAYBOOKS_LOGS';
export const UPDATE_PLAYBOOKS = 'App/UPDATE_PLAYBOOKS';
export const SAVE_PLAYBOOKS = 'App/SAVE_PLAYBOOKS';
export const DELETE_PLAYBOOKS = 'App/DELETE_PLAYBOOKS';
export const RUN_PLAYBOOKS = 'App/RUN_PLAYBOOKS';

//Staff
export const RESET_SET_ORGANIZATION_ACTIVE_STATUS =
  'App/RESET_SET_ORGANIZATION_ACTIVE_STATUS';
export const RESET_SET_ORGANIZATION_INACTIVE_STATUS =
  'App/RESET_SET_ORGANIZATION_INACTIVE_STATUS';
export const LOAD_CUSTOMER_ORGANIZATIONS_LIST =
  'App/LOAD_CUSTOMER_ORGANIZATIONS_LIST';
export const LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE =
  'App/LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE';
export const UPDATE_CUSTOMER_ORGANIZATION = 'App/UPDATE_CUSTOMER_ORGANIZATION';
export const LOAD_MY_SUBSCRIPTION_PLAN = 'App/LOAD_MY_SUBSCRIPTION_PLAN';
export const LOAD_MY_SUBSCRIPTION_LIMIT = 'App/LOAD_MY_SUBSCRIPTION_LIMIT';
export const LOAD_CUSTOMER_SUBSCRIPTION_PLAN =
  'App/LOAD_CUSTOMER_SUBSCRIPTION_PLAN';
export const CREATE_CUSTOMER_SUBSCRIPTION = 'App/CREATE_CUSTOMER_SUBSCRIPTION';
export const UPDATE_CUSTOMER_SUBSCRIPTION = 'App/UPDATE_CUSTOMER_SUBSCRIPTION';
export const RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION =
  'App/RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION';
export const UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION =
  'App/UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION';
export const NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION =
  'App/NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION';
export const CREATE_CUSTOMER_ORGANIZATION = 'App/CREATE_CUSTOMER_ORGANIZATION';
export const LOAD_CUSTOMER_ORGANIZATION = 'App/LOAD_CUSTOMER_ORGANIZATION';
export const DELETE_CUSTOMER_ORGANIZATION = 'App/DELETE_CUSTOMER_ORGANIZATION';
export const LOAD_CUSTOMER_ORGANIZATION_USERS_LIST =
  'App/LOAD_CUSTOMER_ORGANIZATION_USERS_LIST';
export const LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE =
  'App/LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE';
export const UPDATE_CUSTOMER_ORGANIZATION_USER =
  'App/UPDATE_CUSTOMER_ORGANIZATION_USER';
export const CREATE_CUSTOMER_ORGANIZATION_USER =
  'App/CREATE_CUSTOMER_ORGANIZATION_USER';
export const DELETE_CUSTOMER_ORGANIZATION_USER =
  'App/DELETE_CUSTOMER_ORGANIZATION_USER';
export const INVITE_CUSTOMER_ORGANIZATION_USER =
  'App/INVITE_CUSTOMER_ORGANIZATION_USER';
export const ADD_FPs_CUSTOMER_ORGANIZATION_USER =
  'App/ADD_FPs_CUSTOMER_ORGANIZATION_USER'; // add missing pre-defined filter profiles
export const LOAD_USERS_INFO_FOR_STAFF_MEMBER =
  'App/LOAD_USERS_INFO_FOR_STAFF_MEMBER';
export const TRANSTER_USER_FROM_ORG_TO_ANOTHER =
  'App/TRANSTER_USER_FROM_ORG_TO_ANOTHER';
export const CREATE_COMMUNITY_CUSTOMER_ORGANIZATION_USER =
  'App/CREATE_COMMUNITY_CUSTOMER_ORGANIZATION_USER';
export const UPGRADE_COMMUNITY_CUSTOMER_ORGANIZATION_USER =
  'App/UPGRADE_COMMUNITY_CUSTOMER_ORGANIZATION_USER';
export const NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER =
  'App/NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER';
export const SET_ORGANIZATION_ACTIVE = 'App/SET_ORGANIZATION_ACTIVE';
export const SET_ORGANIZATION_INACTIVE = 'App/SET_ORGANIZATION_INACTIVE';

//Download
export const FILE_DOWNLOAD = 'App/FILE_DOWNLOAD';
export const FILE_CONTENT_COPY = 'App/FILE_CONTENT_COPY';
export const LOAD_RESULT_FILE = 'App/LOAD_RESULT_FILE';

//Left Menu
export const HIGHLIGHT_LEFT_MENU = 'App/HIGHLIGHT_LEFT_MENU';
//Blog
export const LOAD_AMBER_REPORTS = 'App/LOAD_AMBER_REPORTS';
export const LOAD_AMBER_REPORT = 'App/LOAD_AMBER_REPORT';
export const LOAD_AMBER_REPORT_COUNT = 'App/LOAD_AMBER_REPORT_COUNT';
export const LOAD_AMBER_REPORT_AUTHORS = 'App/LOAD_AMBER_REPORT_AUTHORS';
export const LOAD_AMBER_REPORT_FEEDS = 'App/LOAD_AMBER_REPORT_FEEDS';
export const LOAD_AMBER_REPORT_TAGS = 'App/LOAD_AMBER_REPORT_TAGS';
export const FILTER_AMBER_REPORTS = 'App/FILTER_AMBER_REPORTS';
export const CHECK_ENRICHMENT_FEED_HAS_BLOGS =
  'App/CHECK_ENRICHMENT_FEED_HAS_BLOGS';
export const RESET_CHECK_ENRICHMENT_FEED_HAS_BLOGS_STATE =
  'App/RESET_CHECK_ENRICHMENT_FEED_HAS_BLOGS_STATE';
export const SET_AMBER_REPORTS_AS_SEEN = 'App/SET_AMBER_REPORTS_AS_SEEN';
export const SET_AMBER_REPORT_UNSEEN = 'App/SET_AMBER_REPORT_UNSEEN';
export const SET_AMBER_REPORT_SEEN = 'App/SET_AMBER_REPORT_SEEN';

//Bulk Data Feeds
export const LOAD_BULK_DATA_FEEDS = 'App/LOAD_BULK_DATA_FEEDS';
export const CLEAR_BULK_DATA_FEEDS = 'App/CLEAR_BULK_DATA_FEEDS';
export const LOAD_BULK_DATA_FEED_OPTIONS = 'App/LOAD_BULK_DATA_FEED_OPTIONS';
export const DOWNLOAD_BULK_DATA_FEED = 'App/DOWNLOAD_BULK_DATA_FEED';

//Data Marketplace
export const LOAD_DATA_MARKETPLACE_CATEGORIES =
  'App/LOAD_DATA_MARKETPLACE_CATEGORIES';
export const LOAD_DATA_MARKETPLACE_FEEDS = 'App/LOAD_DATA_MARKETPLACE_FEEDS';
export const LOAD_DATA_MARKETPLACE_FEED_OPTIONS =
  'App/LOAD_DATA_MARKETPLACE_FEED_OPTIONS';
export const DOWNLOAD_DATA_MARKETPLACE_FEED =
  'App/DOWNLOAD_DATA_MARKETPLACE_FEED';
export const CLEAR_DATA_MARKETPLACE_FEEDS = 'App/CLEAR_DATA_MARKETPLACE_FEEDS';

//DeepScan
export const GET_DEEP_SCAN_METADATA = 'App/GET_DEEP_SCAN_METADATA';
export const SET_CREATE_SPQL_QUERY_STATUS = 'App/SET_CREATE_SPQL_QUERY_STATUS';
export const GET_QUERY_EXAMPLES = 'App/GET_QUERY_EXAMPLES';
export const GET_RECENTLY_RAN_SPQL_QUERIES =
  'App/GET_RECENTLY_RAN_SPQL_QUERIES';
export const GET_SAVED_SPQL_QUERIES = 'App/GET_SAVED_SPQL_QUERIES';
export const CREATE_SPQL_QUERY = 'App/CREATE_SPQL_QUERY';
export const UPDATE_SPQL_QUERY = 'App/UPDATE_SPQL_QUERY';
export const DELETE_SPQL_QUERY = 'App/DELETE_SPQL_QUERY';
export const RESET_DEEP_SCAN_TO_INITIAL_STATE =
  'App/RESET_DEEP_SCAN_TO_INITIAL_STATE';
export const CHANGE_SPQL_QUERY_VALIDATION_MESSAGE =
  'App/CHANGE_SPQL_QUERY_VALIDATION_MESSAGE';
export const GET_DEEP_SCAN = 'App/GET_DEEP_SCAN';
export const CHANGE_SPQL_QUERY = 'App/CHANGE_SPQL_QUERY';
export const CHANGE_SPQL_SORTING = 'App/CHANGE_SPQL_SORTING';
export const CHANGE_SPQL_SELECTED_COLUMNS = 'App/CHANGE_SPQL_SELECTED_COLUMNS';

//Websocket
export const SET_WEBSOCKET_CONNECTION = 'App/SET_WEBSOCKET_CONNECTION';
export const SET_WEBSOCKET_CONNECTION_STATUS =
  'App/SET_WEBSOCKET_CONNECTION_STATUS';

export const STATUS = {
  IDLE: 'idle',
  RUNNING: 'running',
  LOADING: 'loading',
  LOADED: 'loaded',
  READY: 'ready',
  SUCCESS: 'success',
  ERROR: 'error',
  EDIT: 'edit',
  CREATE: 'create',
};

// Notification TYPES
export const NOTIFICATION = {
  ADD_NOTIFICATION: 'App/ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'App/REMOVE_NOTIFICATION',
};
